module.exports = __webpack_public_path__ + "img/Feuerwehrboot.9550435b.svg";